const sensitiveWordsArray = require('./sensitiveWords')
export const filtion = (str) => {
  for (var i = 0; i < sensitiveWordsArray.length; i++) {
    for (var j = 0; j <= str.length - sensitiveWordsArray[i].length; j++) {
      //根据敏感字符个数截取str的字符进行判断
      if (
        sensitiveWordsArray[i] ==
        str.slice(j, j + sensitiveWordsArray[i].length)
      ) {
        return true
      }
    }
  }
  return false
}
